import { GymEnvironment } from '../gym';

export const FREE_TRIAL_PLAN_ID = 'free-trial';
export const HOME_PLAN_ID_FOR_USER_CREATION = 'HOME_ACCOUNT_NO_PLAN';
export const JUICE_PLUS_PLAN_ID_FOR_USER_CREATION = 'JUICE_PLUS_PLAN_ID_FOR_USER_CREATION';
export const WALTONS_PLAN_ID_FOR_USER_CREATION = 'WALTONS_PLAN_ID_FOR_USER_CREATION';
export const PLATFORM_PLAN_ID_FOR_USER_CREATION = 'PLATFORM_PLAN_ID_FOR_USER_CREATION';
export const JNJ_PLAN_ID_FOR_USER_CREATION = 'JNJ_PLAN_ID_FOR_USER_CREATION';
export const IMMERSE_PLAN_ID_FOR_USER_CREATION = 'IMMERSE_PLAN_ID_FOR_USER_CREATION';
export const HOME_ELITE_SA_PLAN_ID_FOR_USER_CREATION = 'HOME_ELITE_SA_PLAN_ID_FOR_USER_CREATION';
export const UW_PLAN_ID_FOR_USER_CREATION = 'UW_PLAN_ID_FOR_USER_CREATION';
export const GO_SMART_WELLNESS_PLAN_ID_FOR_USER_CREATION = 'GO_SMART_WELLNESS_PLAN_ID_FOR_USER_CREATION';
export const PRIMEDIA_PLAN_ID_FOR_USER_CREATION = 'PRIMEDIA_PLAN_ID_FOR_USER_CREATION';
export const ENTELECT_PLAN_ID_FOR_USER_CREATION = 'ENTELECT_PLAN_ID_FOR_USER_CREATION';
export const MK_WELLNESS_PLAN_ID_FOR_USER_CREATION = 'MK_WELLNESS_PLAN_ID_FOR_USER_CREATION';
export const BRYTE_PLAN_ID_FOR_USER_CREATION = 'BRYTE_PLAN_ID_FOR_USER_CREATION';
export const GROWTHPOINT_PLAN_ID_FOR_USER_CREATION = 'GROWTHPOINT_PLAN_ID_FOR_USER_CREATION';

export const homePlanEnvironmentMapForInitialUserSignup: { [key: string]: string[] } = {
  [GymEnvironment.Staging]: [
    'price_1J8QMUGgqUDgVRX64XMznp5J', /* aud 14 day trial */
    'price_1LLhzDGgqUDgVRX6AZKiMwoR', /* aud 7 day trial */

    'price_1LZ5chGgqUDgVRX6LA8ZXsTh', /* usd 14 day trial */
    'price_1LZ5SpGgqUDgVRX6lQS3hodJ', /* usd 7 day trial */

    'price_1LuB03GgqUDgVRX6Q5xDc8ss', /* usd 1 month trial */
    'price_1LuFSRGgqUDgVRX6hplaebDt', /* aud 1 month trial */

    'price_1LuFcqGgqUDgVRX6dInEWerf', /* aud 3 month trial */

    'price_1O4hIRCsT0TSR8Tm4YtxLnma', /* JuicePlusHome 10 day trial */
    'price_1OjflnCsT0TSR8TmTKhzSUmZ', /* JuicePlusHome 30 day trial */
    'price_1O4Q4NCsT0TSR8Tmhk4SRItR', /* JuicePlusHome 1 day licence */
    'price_1NxqunCsT0TSR8TmJ4MKzAbL', /* JuicePlusHome 10 day trial extension */
  ],
  [GymEnvironment.Production]: [
    'price_1K9PygGgqUDgVRX6wBt3sTSx', /* aud 14 day trial */
    'price_1LLkqkGgqUDgVRX6arxQWBaI', /* aud 7 day trial */

    'price_1LZ5aXGgqUDgVRX6V2VyPgUx', /* usd 14 day trial */
    'price_1LWwRnGgqUDgVRX6jr0vcjLb', /* usd 7 day trial */

    'price_1LuFiXGgqUDgVRX6UTzVw7kU', /* usd 1 month trial */
    'price_1LuFiCGgqUDgVRX6xZ1Qiu0j', /* aud 1 month trial */

    'price_1LuFm5GgqUDgVRX6FjAvLRM7', /* aud 3 month trial */

    'price_1O4iMrCsT0TSR8TmEhKdwHPy', /* JuicePlusHome 10 day trial */
    'price_1OjhgGCsT0TSR8TmXivyiQtl', /* JuicePlusHome 30 day trial */
    'price_1O4Q3gCsT0TSR8TmGGWdKdnm', /* JuicePlusHome 1 day licence */
    'price_1ONXSGCsT0TSR8TmPJdGYA1w', /* JuicePlusHome 10 day trial extension */
  ],
};

export const studioPlanEnvironmentMapForInitialUserSignup: { [key: string]: string[] } = {
  [GymEnvironment.Staging]: [
    'price_1MZChLLd8sv8uhTt93IyLpGY', /* 4-week free trial */
    'price_1MU6F0CYhDMVLM8mi9T5T7xt', /* 4-week free trial */
    'price_1MmdNALd8sv8uhTtJWWoFJBq', /* 2-week free trial */
    'price_1OcMocLd8sv8uhTtXcj85fTG', /* 1-week free trial */
    'price_1MrEFQLd8sv8uhTtMBbPQ0gi', /* 5-week free trial */
    'price_1My9IkLd8sv8uhTtAA6PdbWy', /* Brookvale 2-week paid trial */
    'price_1P7DyBAA2YE9DeSlUlF5nIPA', /* Immerse 1-week free */
    'price_1QPij1AcaWctOtVHoG3M0Iao', /* platform 1-week trial */
  ],
  [GymEnvironment.Production]: [
    'price_1MZ8woLd8sv8uhTtdmwhJ1Jv', /* 4-week free trial */
    'price_1MnZfrLd8sv8uhTtPPUHLYFa', /* 2-week free trial */
    'price_1OcMt5Ld8sv8uhTt6b8OQEzR', /* 1-week free trial */
    'price_1MqzwKLd8sv8uhTt3H2BMFGr', /* 5-week free trial */
    'price_1My9ljLd8sv8uhTtm83GhTky', /* Brookvale 2-week paid trial */
    'price_1P7EVGAA2YE9DeSl13xfDvrS', /* Immerse 1-week free */
    'price_1QPkd5AcaWctOtVHIuJ01Kyc', /* platform 1-week trial */
  ],
};

export interface IPlanBasicDetails {
  id: string;
  name: string;
  amount: number;
}

export const homePlanEnvironmentMapForIAP: { [key: string]: string } = {
  [GymEnvironment.Staging]: 'price_1hlw63ggqudgvrx6blunejfc',
  [GymEnvironment.Production]: 'price_1hlw63ggqudgvrx6blunejfc',
};

export const homePlanEnvironmentMapForWebFlow: { [key: string]: string } = {
  [GymEnvironment.Staging]: 'price_1OglViGgqUDgVRX6zKJ5vkzV', // $39.99 per month
  [GymEnvironment.Production]: 'price_1OglZEGgqUDgVRX6GduDREBT', // $39.99 per month
};

export const productEnvironmentMapForIAP: { [key: string]: string } = {
  [GymEnvironment.Staging]: 'prod_IMEZd2QVEwnyip',
  [GymEnvironment.Production]: 'prod_INizPhxbtR4rrK',
};

export const productEnvironmentMapForLite: { [key: string]: string[] } = {
  [GymEnvironment.Staging]: [
    'prod_HrKl1PygNAb3c8',
    'prod_OlNgWSoc6ZOkER' /* JuicePlusHome Standard Home Membership */,
  ],
  [GymEnvironment.Production]: [
    'prod_HrypTWEawEgBil',
    'prod_Os2Zzhnm8Sbaxz', /* JuicePlusHome Standard Home Membership */
  ],
};

export const productEnvironmentMapForEliteStarter: { [key: string]: string } = {
  [GymEnvironment.Staging]: 'prod_LNBm289C7F61wQ',
  [GymEnvironment.Production]: 'prod_LNyx6J8RrYkSvX',
};

export const productEnvironmentMapForElitePro: { [key: string]: string } = {
  [GymEnvironment.Staging]: 'prod_LNtUepQnVmCj1h',
  [GymEnvironment.Production]: 'prod_LNyxH4c7d7qonA',
};

export const homePlanEnvironmentMapForFreeAppAccess: { [key: string]: string } = {
  [GymEnvironment.Staging]: 'price_1KwLQlGgqUDgVRX6sXPLy97a',
  [GymEnvironment.Production]: 'price_1LArMtGgqUDgVRX6sWNtWVO5',
};
